export class BackupVault {
    'id';
    'vaultAccountId';
    'providerAccountId';
    'name';
    'region';
    'isManagedByEon';
    'vaultAttributes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultAccountId",
            "baseName": "vaultAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "isManagedByEon",
            "baseName": "isManagedByEon",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "vaultAttributes",
            "baseName": "vaultAttributes",
            "type": "VaultProviderAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupVault.attributeTypeMap;
    }
    constructor() {
    }
}
